import { Typography } from '@mui/material';
import BorderedBox from '../../../components/BorderedBox';
import { useTenant } from '../../../contexts/TenantContext';
import { gradientTextSx } from '../../../utils/textStyles';
import { formatPrice } from '../../../utils/priceUtils';
import DiscountedPrice from './DiscountedPrice';


/**
 * The chosen service, as the booking funnel shows it: tenant-themed, in the same bordered box
 * as the appointment block it sits next to on the confirmation step.
 *
 * The dashboard has its own version (`features/dashboard/components/SupplyDetails`) because it
 * ignores `displayConfig` entirely — sharing one component across both meant a tenant's accent
 * colour leaking into an admin tool that is deliberately neutral.
 *
 * `coupon`, on the confirmation step, is the coupon the guest redeemed: the price then shows struck
 * through, with the coupon's price beside it.
 */
const SupplySummary = ({ supply, title, titleColor, fixedWidth, coupon }) => {
  const { displayConfig } = useTenant();

  return (
    <BorderedBox title={title} titleColor={titleColor} fixWidth={fixedWidth}>
      <Typography
        sx={gradientTextSx(displayConfig, displayConfig?.selectedSupplyNameColor || displayConfig?.color)}
        fontWeight="bold"
        gutterBottom
      >
        {supply?.name}
      </Typography>

      <Typography variant="body1" color={displayConfig?.color} data-testid="supply-summary-price">
        {coupon
          ? <DiscountedPrice price={coupon.price} originalPrice={coupon.originalPrice} />
          : supply && formatPrice(supply.price)}
      </Typography>

      <Typography variant="body1" color={displayConfig?.color}>
        {supply?.duration} perc
      </Typography>
    </BorderedBox>
  );
};

export default SupplySummary;
